import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useTranslation } from "@/i18n/LanguageContext";
import AccountShell from "@/components/vangard/AccountShell";
import { MemberCard } from "@/components/MemberCard";

const TIER_LINE = {
  silver: "vc.acct.card.silver",
  gold: "vc.acct.card.gold",
  vip: "vc.acct.card.vip",
  corporate: "vc.acct.card.corporate",
};

export default function AccountCardPage() {
  const { user } = useAuth();
  const { t } = useTranslation();
  if (!user) return <AccountShell active="/account/card"><div /></AccountShell>;

  const tier = (user.membership_tier || "silver").toLowerCase();

  return (
    <AccountShell active="/account/card" title={t("vc.acct.nav.card")}>
      <div data-testid="account-card-page">
        <div className="mt-2 max-w-lg">
          <MemberCard user={user} />
        </div>

        <div className="mt-10 rounded-2xl border border-white/[0.08] bg-[#0A0A0A]/80 p-5 flex flex-col sm:flex-row sm:items-center justify-between gap-4 max-w-lg">
          <div>
            <div className="text-[9px] tracking-[0.3em] uppercase text-neutral-500">{t("vc.acct.tier")}</div>
            <div className="text-base font-light mt-1.5">{t(TIER_LINE[tier] || TIER_LINE.silver)}</div>
          </div>
          <Link
            to="/account/membership"
            className="shrink-0 inline-flex items-center justify-center gap-2 border border-white/20 px-5 py-2.5 rounded-full text-[10px] tracking-[0.25em] uppercase hover:bg-white/5 hover:border-white/45 transition-colors"
            data-testid="account-view-tiers"
          >
            {t("vc.acct.card.tiers")}
          </Link>
        </div>
      </div>
    </AccountShell>
  );
}
